import {
  FormControlLabel,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';

interface TextAreaProps extends Omit<ControllerProps, 'render'> {
  name: string;
  label?: string;
  placeholder?: string;
  onChange?: TextFieldProps['onChange'];
  disabled?: boolean;
}

export function TextArea({
  name,
  label,
  placeholder,
  disabled = false,
  onChange,
  ...props
}: TextAreaProps) {
  const methods = useFormContext();
  return (
    <FormControlLabel
      labelPlacement="top"
      className="w-full m-0"
      label={
        <Typography
          className={clsx(
            { 'text-mui-error': methods.formState.errors[name] },
            'ml-6 mb-1 font-bold'
          )}
          alignSelf="start"
        >
          {label}
          {props.rules?.required && !disabled && (
            <span className="ml-1 text-mui-error">*</span>
          )}
        </Typography>
      }
      control={
        <Controller
          {...props}
          rules={!disabled ? props.rules : undefined}
          name={name}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              disabled={disabled}
              className="w-full rounded-full"
              placeholder={placeholder}
              error={!!error}
              helperText={error?.message}
              multiline
              rows={4}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) onChange(e);
              }}
            />
          )}
        />
      }
    />
  );
}
